module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "dedication"
    }
  }, [_c('div', {
    staticClass: "generated-style"
  }, [_c('p', {
    staticClass: "x2fm-ttl",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Contents#dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "x2ded-only",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("To Jane Austen and all those who love her")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d8487de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dedication.vue
// module id = 63
// module chunks = 0